module.exports = __webpack_public_path__ + "media/application/images/icons/bullet-bc297cfc59b0b2fdbb4cc13ed94b9d4b.svg";